// src/subscreens/mechanicadmin/login/MechanicLoginPage.jsx

import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff, FiArrowRight } from "react-icons/fi";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import mechanicImg from "../../../assets/images/home/hero3.jpg";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/mechanic/register/Register.css";

export default function MechanicLoginPage() {
  const navigate = useNavigate();
  const { baseUrl, setAuthToken, setLoggedInMechanic } = useContext(AppContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errormessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const mechanicLogin = () => {
    if (!email || !password) {
      setErrorMessage("Email and password required");
      return;
    }
    setLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/mechanicadmin/authentication/login`, formData)
      .then((response) => {
        setLoading(false);
        localStorage.setItem("authToken", response.data.token);
        setAuthToken(response.data.token);
        localStorage.setItem(
          "LoggedInMechanic",
          JSON.stringify(response.data.mechanicadmin)
        );
        setLoggedInMechanic(response.data.mechanicadmin);
        navigate("/mechanic-admin/dashboard");
      })
      .catch((error) => {
        setLoading(false);
        if (error.response?.status === 404) {
          setErrorMessage("Account not registered. Redirecting to registration...");
          setTimeout(() => navigate("/mechanic-admin/register"), 2000);
        } else if (error.response?.status === 401) {
          setErrorMessage("Invalid Email or Password");
        } else {
          setErrorMessage("Login failed, please try again");
        }
      });
  };

  return (
    <div className="mech-auth-container">
      {/* ── LEFT PANEL ── */}
      <div
        className="mech-auth-left"
        style={{
          backgroundImage: `url(${mechanicImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="mech-auth-overlay" />
        <div className="mech-auth-left-content">
          <span className="mech-badge">FOR SKILLED MECHANICS</span>
          <h1>
            Welcome <br /> Back!
          </h1>
          <p>
            Log in to manage your maintenance jobs, track earnings, and connect
            with farmers across Pakistan.
          </p>
        </div>
      </div>

      {/* ── RIGHT PANEL ── */}
      <div className="mech-auth-right">
        <div className="mech-form-scroll">
          <div className="mech-form-card">
            <div className="mech-form-header">
              <h2>Login to Your Account</h2>
              <p>Enter your credentials to access your dashboard.</p>
            </div>

            <form>
              <div className="mech-form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="mech-form-group">
                <label>Password</label>
                <div className="mech-input-eye">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <p style={{ textAlign: "right", marginTop: "8px" }}>
                <span
                  onClick={() => navigate("/general/forgot-password/mechanic")}
                  style={{
                    color: "#FDB714",
                    fontWeight: "600",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontSize: "0.85rem",
                  }}
                >
                  Forgot Password?
                </span>
              </p>

              {errormessage && <p className="mech-error-msg">{errormessage}</p>}

              <button
                type="button"
                className="mech-submit-btn"
                onClick={mechanicLogin}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" style={{ marginRight: "8px" }} />
                    Logging In...
                  </>
                ) : (
                  <>
                    Login <FiArrowRight />
                  </>
                )}
              </button>

              <p className="mech-auth-switch">
                Don't have an account?{" "}
                <span onClick={() => navigate("/mechanic-admin/register")}>
                  Sign Up
                </span>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}